import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CalendarIcon,
  CashIcon,
  ClockIcon,
  LocationMarkerIcon,
  UsersIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import moment from "moment";
import React, { useCallback, useEffect, useState, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideBar from "../../../components/b2b/SideBar";
import AutoCompletePlaceItem, {
  AutoCompletePlaceItemFlatRegion,
} from "../../../components/b2c/AutoCompletePlaceItem";
import Header from "../../../components/landingPage/Header";
import InputField from "../../../components/landingPage/InputField";
// import { TimePicker } from "react-ios-time-picker";
import "./DatePicker.css";
// import TimePicker from "../../../utils/TimePicker/TimePicker";
import {
  clearCurrency,
  clearPassenger,
  getDateTimeDetailIST,
  getDistanceInKm,
  getDuration,
  getLatLanOfDestination,
  getLatLanOfSource,
  searchingCarsWaiting,
  selectPassenger,
  setBookingDateChange,
  setBookingDetails,
  setConvertedPrice,
  setCurrency,
  setPostalCodeDestination,
  setPostalCodeSource,
} from "../../../redux/app/booking/booking-slice";
import {
  changeDestinationInput,
  changeSourceInput,
  clearDestinationInput,
  clearSourceInput,
  setDestinationInput,
  setSourceInput,
} from "../../../redux/app/map/map-slice";
import {
  getVehicles,
  getVehiclesErr,
} from "../../../redux/app/vehicle/vehicle-slice";
import momenttz from "moment-timezone";
import GoogleIcon from "../../../assets/icons/google.png";
import SearchResultHeading from "../../../components/b2c/SearchResultHeading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faDotCircle,
  faRoad,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import DatePicker from "react-date-picker";
import { toast } from "react-toastify";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import LoadingIcon from "../../../components/loading/LoadingIcon";
import { BookingInputField } from "../NewBooking/NewBooking";

function FlatRates() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user, userLoading } = useSelector((state) => state.auth);
  const { companyPermission } = useSelector((state) => state.company);
  const { settings } = useSelector((state) => state.settings);
  const [formSwitchOneWay, setformSwitchOneWay] = useState(true);
  const {
    sourceInputFromApi,
    sourceInput,
    placesbygoogle,
    placesbygoogleForDestination,
  } = useSelector((state) => state.map);
  const [openTimePicker, setOpenTimePicker] = useState(false);
  const {
    selectedPassenger,
    timeDetails,
    selectdCurrency,
    sourceLatLan,
    destinationLatLan,
    distanceInKm,
    distance,
    isSearhingCar,
    checkSourceRegion,
    checkDestinationRegion,
    postalCodeSource,
    postalCodeDestination,
    booking,
  } = useSelector((state) => state.booking);
  const { companyDetails } = useSelector((state) => state.company);

  const { vehicles, err } = useSelector((state) => state.vehicle);

  const [dateChange, setDateChange] = useState(undefined);
  const [timeChange, setTimeChange] = useState("10:00");
  const [tzUpdate, setTzUpdate] = useState(undefined);
  const [hourlyTime, sethourlyTime] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [timeValue, setTimeValue] = useState("10:01");

  const [searchLoading, setsearchLoading] = useState(false);

  let time = dateChange + " " + timeChange; // timeDetails.timezone_location

  useEffect(() => {
    let t = moment(time).format("YYYY-MM-DD HH:mm ");
    setTzUpdate(t);
  }, [timeDetails.timezone, time]);

  useEffect(() => {
    dispatch(
      getLatLanOfSource({
        sourceLatLan: "",
      })
    );
    dispatch(
      getLatLanOfDestination({
        destinationLatLan: "",
      })
    );
  }, []);

  useEffect(() => {
    if (sourceLatLan && destinationLatLan) {
      dispatch({
        type: "GET_DISTANCE_BETWEEN_SOURCE_AND_DESTINATION",
        payload: {
          sourcelatlng: sourceLatLan,
          destlatlng: destinationLatLan,
        },
      });
    }
  }, [sourceLatLan, destinationLatLan, dispatch]);

  // useEffect(() => {
  //   if (!localStorage.getItem("newbookingreload")) {
  //     localStorage.setItem("newbookingreload", "true");
  //     window.location.reload();
  //   }
  // }, []);

  const [openDatePicker, setopenDatePicker] = useState(false);
  const [openPassengerSelect, setopenPassengerSelect] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);

  // const wrapperRef = useRef("");
  // outsideClick(wrapperRef, () => {
  //   setOpenCurrency(false);
  // });

  let passenger = [];
  for (let i = 0; i < 6; i++) {
    passenger.push(i + 1);
  }

  let Currency = [
    "USD",
    "INR",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "JPY",
    "AED",
    "CNY",
    "KWD",
    "NZD",
    "QAR",
    "SAR",
    "SGD",
    "OMR",
  ];

  const [openHour, setOpenHour] = useState(false);

  let travelTimeInSeconds = new Date(tzUpdate).getTime() / 1000;
  let currentTimeInSeconds = new Date(timeDetails?.date_time).getTime() / 1000;
  let timeDiffInSeconds = Math.abs(travelTimeInSeconds - currentTimeInSeconds);

  const [isTimeChange, setisTimeChange] = useState(false);
  const [dateValue, setDateValue] = useState();

  //
  // handlers
  const handleTimeChange = useCallback(
    (timeValue) => {
      setisTimeChange(true);

      setTimeValue(timeValue);
      setTimeChange(timeValue);
    },
    [dispatch, sourceInputFromApi]
  );

  const [sourceRegionInput, setsourceRegionInput] = useState("");
  const [destinationRegionInput, setdestinationRegionInput] = useState("");
  const [sourceSuggestionOpen, setSourceSuggestionOpen] = useState(false);
  const [destinationSuggestionOpen, setDestinationSuggestionOpen] =
    useState(false);
  const [sourcePlaceId, setsourcePlaceId] = useState();
  const [destinationPlaceId, setdestinationPlaceId] = useState();
  const [sourcePlace, setsourcePlace] = useState();
  const [destinationPlace, setdestinationPlace] = useState();

  useEffect(() => {
    const getPlacesFromGoogleData = setTimeout(() => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeSourceInput({
          sourceInput: sourceRegionInput,
        })
      );
      if (sourceRegionInput?.length > 2 && sourceSuggestionOpen) {
        if (companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT") {
          console.log("without");
          dispatch({
            type: "GET_PLACES_FROM_GOOGLE",
            payload: sourceRegionInput,
          });
        } else {
          dispatch({
            type: "SEARCH_PLACES_BY_NAME_SOURCE",
            payload: sourceRegionInput,
          });
        }
      }
    }, 200);
    return () => clearTimeout(getPlacesFromGoogleData);
  }, [sourceRegionInput, sourceSuggestionOpen]);

  useEffect(() => {
    if (sourcePlaceId) {
      dispatch(
        getDistanceInKm({
          distance: undefined,
        })
      );
      dispatch({
        type: "MATCHING_REGION_SOURCE",
        payload: {
          sourcePLaceId: sourcePlaceId,
        },
      });
    }
  }, [sourcePlaceId, dispatch]);

  // when currency is changed

  useEffect(() => {
    if (destinationPlaceId) {
      dispatch(
        getDistanceInKm({
          distance: undefined,
        })
      );
      dispatch({
        type: "MATCHING_REGION_DESTINATION",
        payload: {
          destPLaceId: destinationPlaceId,
        },
      });
    }
  }, [destinationPlaceId, dispatch]);

  useEffect(() => {
    const getPlacesFromGoogleDataDestination = setTimeout(() => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeDestinationInput({
          destinationInput: destinationRegionInput,
        })
      );
      if (destinationRegionInput?.length > 2 && destinationSuggestionOpen) {
        if (companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT") {
          dispatch({
            type: "GET_PLACES_FROM_GOOGLE_FOR_DEST",
            payload: destinationRegionInput,
          });
        } else {
          dispatch({
            type: "SEARCH_PLACES_BY_NAME_DEST",
            payload: destinationRegionInput,
          });
        }
      }
    }, 200);
    return () => clearTimeout(getPlacesFromGoogleDataDestination);
  }, [destinationRegionInput, destinationSuggestionOpen]);

  useEffect(() => {
    if (timeDetails?.timezone && !isTimeChange) {
      let timezonevalue = momenttz
        .tz(timeDetails.datetime, timeDetails?.timezone)
        .format("HH:mm");

      let t = momenttz
        .tz(timeDetails.datetime, timeDetails?.timezone)
        .format("HH:mm a");

      // setTimeValue(timezone.toString());
      setTimeValue(timezonevalue);
      setTimeChange(timezonevalue);
    }
  }, [timeDetails?.timezone, timeDetails?.date_time, isTimeChange]);

  // removing distance value
  useEffect(() => {
    dispatch(
      getDistanceInKm({
        distance: undefined,
      })
    );
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);

    if (
      sourceInput === undefined ||
      tzUpdate === undefined ||
      dateChange === undefined
    ) {
      toast.warning("Please fill all the fields", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
      });
    } else {
      setsearchLoading(true);

      const payload = {
        source: {
          placename:
            companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT"
              ? sourcePlace?.description + " " + postalCodeSource
              : sourcePlace,
          placeid: sourcePlace?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        destination: {
          placename:
            companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT"
              ? destinationPlace?.description + " " + postalCodeDestination
              : destinationPlace,
          placeid: destinationPlace?.place_id,
          lat: destinationLatLan.split(",")[0],
          lng: destinationLatLan.split(",")[1],
        },
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
        userName: user.userName,
        user: user._id,
        timeZone: timeDetails.timezone,
      };

      dispatch(
        setBookingDetails({
          booking: payload,
        })
      );
      if (formSwitchOneWay) {
        dispatch({
          type: "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE",
          payload: {
            b2b: true,
            navigate,
            distanceInKm: distanceInKm?.km,
            source: {
              lat: sourceLatLan.split(",")[0],
              lng: sourceLatLan.split(",")[1],
            },
            sourceLatLan,
            destinationLatLan,
            destination: {
              lat: destinationLatLan.split(",")[0],
              lng: destinationLatLan.split(",")[1],
            },
          },
        });

        // if (
        //   // checkDestinationRegion &&
        //   // checkSourceRegion &&
        //   sourceLatLan &&
        //   destinationLatLan &&
        //   // dateChange &&
        //   distance
        //   // // timeValue &&
        //   // selectdCurrency
        // ) {
        //
        //   dispatch({
        //     type: "GET_VEHICLES_WITH_FLAT_PRICE",
        //     payload: {
        //       sourceLatLng: sourceLatLan,
        //       destinationLatLng: destinationLatLan,
        //       km: distance,
        //       userId: user._id,
        //       date: dateChange,

        //       time: timeValue,
        //       currency: selectdCurrency,
        //     },
        //   });
        // }
      }
    }
  };

  useEffect(() => {
    if (
      sourceLatLan &&
      destinationLatLan &&
      dateChange &&
      distance &&
      timeValue &&
      selectdCurrency
    ) {
      dispatch({
        type: "GET_VEHICLES_WITH_FLAT_PRICE",
        payload: {
          sourceLatLng: sourceLatLan,
          destinationLatLng: destinationLatLan,
          km: distance,
          userId: user._id,
          date: dateChange,
          time: timeValue,
          currency: selectdCurrency,
        },
      });
    }
  }, [
    sourceLatLan,
    destinationLatLan,
    distance,
    selectdCurrency,
    timeValue,
    dateChange,
  ]);

  useEffect(() => {
    dispatch(getDateTimeDetailIST({ dateTimeIST: {} }));
  }, []);

  useEffect(() => {
    if (booking?.timeZone && booking?.travelTime) {
      dispatch({
        type: "GET_DATE_TIME_DETAILS_IST",
        payload: {
          travellDateTime: booking?.travelTime,
          IndianTimezone: "Asia/Kolkata",
          travellTimeZone: booking?.timeZone,
        },
      });
    }
  }, [booking?.timeZone, booking?.travelTime]);

  useEffect(() => {
    if (distance && vehicles !== undefined && isSubmit) {
      navigate("/flatrates/searchResult");
      setIsSubmit(false);
      setsearchLoading(false);
    }
    if (err) {
      toast.warning(err, {
        position: "top-center",
        autoClose: 9000,
        hideProgressBar: false,
      });
      setsearchLoading(false);
    }
  }, [dispatch, distance, vehicles, isSubmit, navigate, err]);

  return (
    <div className="fixed w-screen max-h-full">
      {/* <div className="fixed w-screen scrollbar max-h-full overflow-y-auto"> */}
      <Header token={token} />
      <div className="flex">
        <SideBar />

        <div className="h-screen w-full my-5">
          <div className="flex justify-between mx-2 sm:mx-10 text-center">
            <SearchResultHeading
              searchCurrent={true}
              showBookingDetail={false}
            />
          </div>

          <div className="relative">
            <div
              className="absolute w-full h-screen"
              onClick={() => {
                setopenPassengerSelect(false);
                setOpenCurrency(false);
                setSourceSuggestionOpen(false);
                setDestinationSuggestionOpen(false);
                setOpenHour(false);
                setOpenTimePicker(false);
              }}
            ></div>

            <div className="h-screen w-full my-5 px-3 sm:px-8 lg:px-16 xl:px-20">
              <div className="relative mt-6 sm:w-[86%] md:w-full lg:mx-0 mx-3 sm:mx-5 md:mx-0 shadow-md px-5 sm:px-10 md:px-5 border border-gray-300 rounded-md pt-5 pb-10">
                <form action="" className="space-y-4 ">
                  {/* source input */}
                  <div className="space-y-4">
                    <BookingInputField
                      placeHolder="Address, Hotel, Airport"
                      Icon={LocationMarkerIcon}
                      label="From"
                      type="text"
                      disabled={
                        user.permission?.newBooking?.performSearch
                          ?.permission === "DISABLE"
                          ? true
                          : false
                      }
                      value={
                        sourceRegionInput
                        // sourceInputFromApi
                        //   ? sourceInputFromApi?.terms[0]?.value +
                        //     " " +
                        //     sourceInputFromApi?.terms[1]?.value +
                        //     " " +
                        //     sourceInputFromApi?.terms[2]?.value
                        //   : sourceRegionInput
                      }
                      onChange={(e) => {
                        setsourcePlaceId("");
                        setsourceRegionInput(e.target.value);
                        setSourceSuggestionOpen(true);
                        setsourcePlace("");
                        dispatch(
                          getLatLanOfSource({
                            sourceLatLan: "",
                          })
                        );
                      }}
                      onClick={() => {
                        setOpenTimePicker(false);
                        setOpenCurrency(false);
                        setopenPassengerSelect(false);
                        setOpenHour(false);
                        setDestinationSuggestionOpen(false);
                      }}
                    />

                    {placesbygoogle.length > 0 && sourceSuggestionOpen && (
                      <>
                        <div className="bg-[#eae9e9] absolute w-[90%] sm:w-[85%] md:w-[82%] lg:w-[88%] xl:w-[91%] 2xl:w-[93%] mx-20 h-72 -translate-x-20 -translate-y-3.5 scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                          <div className="overflow-y-auto">
                            {placesbygoogle?.map((place) => (
                              <>
                                {companyPermission?.flatRateBooking
                                  ?.MeetAndGreet === "WITHOUT" ? (
                                  <AutoCompletePlaceItem
                                    onClick={() => {
                                      // setting source input to input field and to redux store
                                      // dispatch(
                                      //   setSourceInput({
                                      //     sourceInputFromApi: place,
                                      //   })
                                      // );
                                      let selectedPlace =
                                        place?.terms[0]?.value +
                                        " " +
                                        place?.terms[1]?.value +
                                        " " +
                                        place?.terms[2]?.value;
                                      setsourcePlace(place);
                                      setsourceRegionInput("");
                                      setsourceRegionInput(place?.description);
                                      // and the same time finding lat an  lng to store to db and to get distance
                                      dispatch({
                                        type: "GET_LAT_LAN_OF_SOURCE",
                                        payload: place.place_id,
                                      });

                                      setsourcePlaceId(place.place_id);
                                      setSourceSuggestionOpen(false);
                                    }}
                                    key={place?.place_id}
                                    placeTerms={place?.terms}
                                  />
                                ) : (
                                  <AutoCompletePlaceItemFlatRegion
                                    onClick={() => {
                                      // setting source input to input field and to redux store
                                      // dispatch(
                                      //   setSourceInput({
                                      //     sourceInputFromApi: place,
                                      //   })
                                      // );

                                      setsourcePlace(
                                        `${
                                          place?.category === "airport"
                                            ? `${place?.name} ${
                                                place?.iata
                                                  ? `(${place?.iata})`
                                                  : ""
                                              },${place?.cityName},${
                                                place?.country
                                              }`
                                            : `${place?.name},${
                                                place?.address?.addressOne
                                              },${place?.cityName} ${
                                                place?.country
                                                  ? place?.country
                                                  : ""
                                              }`
                                        }`
                                      );
                                      setsourceRegionInput("");
                                      setsourceRegionInput(
                                        `${
                                          place?.category === "airport"
                                            ? `${place?.name} ${
                                                place?.iata
                                                  ? `(${place?.iata})`
                                                  : ""
                                              },${place?.cityName},${
                                                place?.country
                                              }`
                                            : `${place?.name},${
                                                place?.address?.addressOne
                                              },${place?.cityName} ${
                                                place?.country
                                                  ? place?.country
                                                  : ""
                                              }`
                                        }`
                                      );
                                      dispatch(
                                        getLatLanOfSource({
                                          sourceLatLan:
                                            place?.lat + "," + place?.lng,
                                        })
                                      );
                                      dispatch(
                                        setPostalCodeSource({
                                          postalCodeSource:
                                            place?.hotelAddresses &&
                                            place?.hotelAddresses?.postalCode
                                              ? place?.hotelAddresses
                                                  ?.postalCode
                                              : "",
                                        })
                                      );
                                      // and the same time finding lat an  lng to store to db and to get distance
                                      // dispatch({
                                      //   type: "GET_LAT_LAN_OF_SOURCE",
                                      //   payload: place.place_id,
                                      // });

                                      // setsourcePlaceId(place.place_id);
                                      setSourceSuggestionOpen(false);
                                      dispatch({
                                        type: "GET_TIME_DETAILS",
                                        payload: {
                                          lng: parseFloat(place?.lng),
                                          lat: parseFloat(place?.lat),
                                        },
                                      });
                                    }}
                                    key={place?._id}
                                    placeTerms={place}
                                  />
                                )}
                              </>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                    {/* source input end */}
                    {formSwitchOneWay ? (
                      <>
                        {/* destination input start */}
                        <BookingInputField
                          placeHolder="Address, Hotel, Airport"
                          Icon={LocationMarkerIcon}
                          label="To"
                          type="text"
                          disabled={
                            user.permission?.newBooking?.performSearch
                              ?.permission === "DISABLE"
                              ? true
                              : false
                          }
                          value={destinationRegionInput}
                          onChange={(e) => {
                            dispatch(
                              getLatLanOfDestination({
                                destinationLatLan: "",
                              })
                            );
                            setdestinationPlaceId("");
                            setdestinationRegionInput(e.target.value);
                            setDestinationSuggestionOpen(true);
                            setdestinationPlace("");
                          }}
                          onClick={() => {
                            setOpenTimePicker(false);
                            setOpenCurrency(false);
                            setopenPassengerSelect(false);
                            setOpenHour(false);
                            setSourceSuggestionOpen(false);
                          }}
                        />

                        {placesbygoogleForDestination.length > 0 &&
                          destinationSuggestionOpen && (
                            <>
                              <div className="bg-[#eae9e9] absolute w-[90%] sm:w-[85%] md:w-[82%] lg:w-[88%] xl:w-[91%] 2xl:w-[93%] mx-20 h-72 -translate-x-20 -translate-y-3.5  scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                                <div className="overflow-y-auto">
                                  {placesbygoogleForDestination?.map(
                                    (place) => (
                                      <>
                                        {companyPermission?.flatRateBooking
                                          ?.MeetAndGreet === "WITHOUT" ? (
                                          <AutoCompletePlaceItem
                                            onClick={() => {
                                              let selectedPlace =
                                                place?.terms[0]?.value +
                                                " " +
                                                place?.terms[1]?.value +
                                                " " +
                                                place?.terms[2]?.value;
                                              setdestinationPlace(place);
                                              setdestinationRegionInput("");
                                              setdestinationRegionInput(
                                                place?.description
                                              );

                                              dispatch({
                                                type: "GET_LAT_LAN_OF_DESTINATION",
                                                payload: place.place_id,
                                              });
                                              setdestinationPlaceId(
                                                place.place_id
                                              );
                                              setDestinationSuggestionOpen(
                                                false
                                              );
                                            }}
                                            key={place?.place_id}
                                            placeTerms={place?.terms}
                                          />
                                        ) : (
                                          <AutoCompletePlaceItemFlatRegion
                                            onClick={() => {
                                              // dispatch(
                                              //   setDestinationInput({
                                              //     destinationInputFromApi: place,
                                              //   })
                                              // );

                                              setdestinationPlace(
                                                `${
                                                  place?.category === "airport"
                                                    ? `${place?.name} ${
                                                        place?.iata
                                                          ? `(${place?.iata})`
                                                          : ""
                                                      },${place?.cityName},${
                                                        place?.country
                                                      }`
                                                    : `${place?.name},${
                                                        place?.address
                                                          ?.addressOne
                                                      },${place?.cityName} ${
                                                        place?.country
                                                          ? place?.country
                                                          : ""
                                                      }`
                                                }`
                                              );
                                              setdestinationRegionInput("");
                                              setdestinationRegionInput(
                                                `${
                                                  place?.category === "airport"
                                                    ? `${place?.name} ${
                                                        place?.iata
                                                          ? `(${place?.iata})`
                                                          : ""
                                                      },${place?.cityName},${
                                                        place?.country
                                                      }`
                                                    : `${place?.name},${
                                                        place?.address
                                                          ?.addressOne
                                                      },${place?.cityName} ${
                                                        place?.country
                                                          ? place?.country
                                                          : ""
                                                      }`
                                                }`
                                              );
                                              dispatch(
                                                getLatLanOfDestination({
                                                  destinationLatLan:
                                                    place?.lat +
                                                    "," +
                                                    place?.lng,
                                                })
                                              );
                                              dispatch(
                                                setPostalCodeDestination({
                                                  postalCodeDestination:
                                                    place?.hotelAddresses &&
                                                    place?.hotelAddresses
                                                      ?.postalCode
                                                      ? place?.hotelAddresses
                                                          ?.postalCode
                                                      : "",
                                                })
                                              );

                                              // dispatch({
                                              //   type: "GET_LAT_LAN_OF_DESTINATION",
                                              //   payload: place.place_id,
                                              // });
                                              // setdestinationPlaceId(place.place_id);
                                              setDestinationSuggestionOpen(
                                                false
                                              );
                                            }}
                                            key={place?._id}
                                            placeTerms={place}
                                          />
                                        )}
                                      </>
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        {/* destination input end */}
                      </>
                    ) : (
                      <>
                        <BookingInputField
                          placeHolder="1 hour (20 Km)"
                          Icon={LocationMarkerIcon}
                          label="Duration"
                          type="text"
                          value={
                            hourlyTime
                              ? hourlyTime?.hour +
                                " hour (" +
                                hourlyTime?.distance +
                                " Km)"
                              : ""
                          }
                          onClick={() => {
                            setOpenHour(true);
                            setOpenCurrency(false);
                            setopenPassengerSelect(false);
                            setSourceSuggestionOpen(false);
                            setDestinationSuggestionOpen(false);
                            setOpenTimePicker(false);
                          }}
                        />
                      </>
                    )}
                  </div>

                  <div className="gap-5 md:flex md:space-x-2">
                    <div className="w-full grow">
                      {/* <BookingInputField
                    Icon={CalendarIcon}
                    placeHolder="01/01/2022"
                    label="Date"
                    inputType="text"
                    value={dateValue}
                    onClick={() => {
                      setopenDatePicker(true);
                    }}
                  
                  /> */}

                      <div className="w-full newbooking">
                        <div className="font-body text-gray-800 text-sm font-semibold">
                          Date
                        </div>
                        <DatePicker
                          className="w-24"
                          format="dd-MM-y"
                          // placeHolder="dd-mm-yy"
                          dayPlaceholder="DD"
                          monthPlaceholder="MM"
                          yearPlaceholder="YYYY"
                          minDate={new Date(moment().subtract(1, "day"))}
                          // yesterday = {today.setDate(- 1)}
                          onChange={(e) => {
                            setDateValue(e);
                            setDateChange(moment(e).format("yyyy-MM-DD"));
                            dispatch(
                              setBookingDateChange({
                                dateChange: moment(e).format("yyyy-MM-DD"),
                              })
                            );
                          }}
                          onClick={() => {
                            setOpenCurrency(false);
                            setopenPassengerSelect(false);
                            setSourceSuggestionOpen(false);
                            setDestinationSuggestionOpen(false);
                            setOpenTimePicker(false);
                            setOpenHour(false);
                          }}
                          value={dateValue}
                        />
                      </div>
                    </div>

                    <div className="relative w-full grow sm:mt-4 md:mt-0">
                      {Math.floor(timeDiffInSeconds / 3600) < 24 && (
                        // {true && (
                        <>
                          <div className="absolute transform translate-y-[100px] translate-x-[40px] animate p-3 rounded-md text-secondary font-semibold">
                            {user.role === "USER" && (
                              <span className="text-sm">
                                Time must be at least 24 hours from pick up time
                              </span>
                            )}
                          </div>
                        </>
                      )}
                      <div className="mt-5 sm:mt-0">
                        <div className="font-body text-sm text-gray-800 font-semibold">
                          Time
                        </div>
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
                        {/* <DemoContainer components={["TimePicker"]}> */}
                        {/* <TimePicker label="Basic time picker" /> */}
                        {/* 24 hours time */}
                        <div className="flex space-x-2">
                          <input
                            onClick={() => {
                              setOpenTimePicker(true);
                              setOpenCurrency(false);
                              setopenPassengerSelect(false);
                              setSourceSuggestionOpen(false);
                              setDestinationSuggestionOpen(false);
                              setOpenHour(false);
                            }}
                            type="time"
                            value={timeValue}
                            onChange={(e) => {
                              setisTimeChange(true);

                              setTimeValue(e.target.value);
                              setTimeChange(e.target.value);
                            }}
                            // 24 hours format
                          />
                          <ArrowRightIcon className="w-5" />
                          {/* </DemoContainer> */}
                          {/* </LocalizationProvider> */}

                          {/* {openTimePicker && (
                            <div className="absolute translate-y-5 ">
                              <div className="animate__animated animate__fadeIn ">
                                <TimePicker
                                  onHandleTimeChange={handleTimeChange}
                                  onClickClose={() => {
                                    setOpenTimePicker(false);
                                  }}
                                  timeValue={timeValue}
                                />
                              </div>
                            </div>
                          )} */}
                          <div
                            className="textField  cursor-pointer"
                            onClick={() => {
                              setOpenTimePicker(true);
                              setOpenCurrency(false);
                              setopenPassengerSelect(false);
                              setSourceSuggestionOpen(false);
                              setDestinationSuggestionOpen(false);
                              setOpenHour(false);
                              setopenDatePicker(false);
                            }}
                          >
                            {timeValue}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-row gap-5 md:flex md:space-x-2">
                    <div className="w-full grow sm:mb-3">
                      <BookingInputField
                        Icon={UsersIcon}
                        placeHolder="Select passenger"
                        label="Passenger"
                        value={selectedPassenger}
                        onClickClear={() => {
                          dispatch(clearPassenger());
                        }}
                        onChange={() => {}}
                        onClick={() => {
                          setopenPassengerSelect(true);
                          setOpenCurrency(false);
                          setSourceSuggestionOpen(false);
                          setDestinationSuggestionOpen(false);
                          setOpenTimePicker(false);
                          setOpenHour(false);
                          setopenDatePicker(false);
                        }}
                      />

                      {/* passenger dropdown start */}
                      {openPassengerSelect && (
                        <>
                          <div className="bg-slate-100 absolute w-auto mx-20 h-auto transform -translate-y-5 -translate-x-20 scrollbar rounded-bl-md rounded-br-md shadow-2xl overflow-y-auto">
                            <div>
                              {passenger.map((passenger) => (
                                <>
                                  <div
                                    key={passenger}
                                    onClick={() => {
                                      dispatch(
                                        selectPassenger({
                                          selectedPassenger:
                                            passenger +
                                            ` ${
                                              passenger > 1
                                                ? "Passengers"
                                                : "Passenger"
                                            } `,
                                        })
                                      );
                                      setopenPassengerSelect(false);
                                    }}
                                    className="flex items-center  px-3 pr-20 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                                  >
                                    <span>{passenger}</span>
                                    <span>
                                      {passenger > 1
                                        ? "Passengers"
                                        : "Passenger"}
                                    </span>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="w-full grow mt-4 sm:mt-4 md:mt-0">
                      <BookingInputField
                        Icon={CashIcon}
                        placeHolder="Select Currency"
                        label="Currency"
                        value={selectdCurrency}
                        onClickClear={() => {
                          dispatch(clearCurrency());
                        }}
                        onChange={() => {}}
                        onClick={() => {
                          setOpenCurrency(true);
                          setopenPassengerSelect(false);
                          setSourceSuggestionOpen(false);
                          setDestinationSuggestionOpen(false);
                          setOpenTimePicker(false);
                          setOpenHour(false);
                          setopenDatePicker(false);
                        }}
                      />

                      {openCurrency && (
                        <>
                          <div className="bg-slate-100 absolute w-[30%] md:w-[25%] lg:w-[20%] mx-20 h-48 transform -translate-x-20 -translate-y-5  scrollbar rounded-bl-md rounded-br-md shadow-2xl">
                            <div className="overflow-y-auto scrollbar max-h-48">
                              {Currency.map((c, index) => (
                                <>
                                  <div
                                    key={index}
                                    onClick={() => {
                                      dispatch(
                                        setCurrency({
                                          selectdCurrency: c,
                                        })
                                      );
                                      setOpenCurrency(false);
                                    }}
                                    className="flex items-center px-3 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                                  >
                                    <span>{c}</span>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                          <div onClick={() => setOpenCurrency(false)}></div>
                        </>
                      )}
                    </div>
                  </div>
                  {/* passenger dropdown end */}
                  {/* {!(Math.floor(timeDiffInSeconds / 3600) < 24) && ( */}
                  {user.role === "ADMIN" ? (
                    <>
                      <button
                        onClick={handleSubmit}
                        className={`outline outline-1 outline-[#c4c6ca] text-[#FB4156] ${
                          isSearhingCar && "cursor-not-allowed"
                        }  hover:outline-[#f3596b] hover:outline-2 hover:shadow-lg hover:shadow-red-100  w-4/5 md:w-1/2 mx-auto justify-center mt-10 flex font-bold text-mb  py-2 rounded-sm font-body`}
                      >
                        {!searchLoading ? (
                          "BOOK A RIDE"
                        ) : (
                          <>
                            <div className="flex items-center justify-center space-x-2 ">
                              <div>Searching cars</div>
                              <LoadingIcon />
                            </div>
                          </>
                        )}
                      </button>
                    </>
                  ) : (
                    <>
                      {!(Math.floor(timeDiffInSeconds / 3600) < 24) && (
                        <button
                          onClick={handleSubmit}
                          className={`outline outline-1 outline-[#c4c6ca] text-[#FB4156] ${
                            isSearhingCar && "cursor-not-allowed"
                          }  hover:outline-[#f3596b] hover:outline-2 hover:shadow-lg hover:shadow-red-100  w-1/2 mx-auto justify-center mt-10 flex font-semibold text-mb  py-2 rounded-sm`}
                        >
                          {!searchLoading ? (
                            "BOOK A RIDE"
                          ) : (
                            <>
                              <div className="flex items-center justify-center space-x-2 ">
                                <div>Searching cars</div>
                                <LoadingIcon />
                              </div>
                            </>
                          )}
                        </button>
                      )}
                    </>
                  )}

                  {/* )} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlatRates;
